import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface PropData {
  st: any;
  message: any;
  position: any;
  id: string;
  /* Render the overlay somewhere other than next to the trigger. Needed when
     the trigger sits inside a scrolling/clipping container, such as the
     sidebar, which would otherwise cut the tooltip off. */
  container?: any;
  className?: string;
}

export const TooltipCustom = (props: PropData) => {
  const tool = <Tooltip id={props.id} className={props.className} style={{ position: "fixed" }}>
    {props.message}
  </Tooltip>
  return (
    <OverlayTrigger placement={props.position} overlay={tool} container={props.container}>
      {props.st}
    </OverlayTrigger>
  );
};
